import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15617b7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lnr-calendar-full InputIcon" }, null, -1 /* HOISTED */));
const _hoisted_2 = {
    key: 0,
    class: "ErrorMessage"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["min", "max"];
const _hoisted_5 = {
    key: 2,
    ref: "largePicker",
    tabindex: "0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LargePicker = _resolveComponent("LargePicker");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["PickerContainer", { 'is-invalid': _ctx.isInvalid }])
    }, [
        _createElementVNode("div", {
            class: "SCTextInput InputContainer",
            onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.monthClicked($event)))
        }, [
            _withDirectives(_createElementVNode("input", {
                onInput: _cache[0] || (_cache[0] = ($event) => (_ctx.onTextInput())),
                onKeypress: _cache[1] || (_cache[1] = _withKeys(($event) => (_ctx.onEnterClicked()), ["enter"])),
                onKeydown: _cache[2] || (_cache[2] = _withKeys(($event) => (_ctx.onEnterClicked()), ["esc"])),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.inputText) = $event)),
                class: "PickerInput",
                type: "text",
                ref: "dateTextInput",
                spellcheck: "false"
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, _ctx.inputText]
            ]),
            _createElementVNode("label", null, _toDisplayString(_ctx.label), 1 /* TEXT */),
            _hoisted_1
        ]),
        (_ctx.isInvalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        (_ctx.showNativePicker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                    ref: "nativePicker",
                    type: "month",
                    class: "MonthSelect",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.selectedDate) = $event)),
                    min: _ctx.minDate,
                    max: _ctx.maxDate,
                    onChange: _cache[6] || (_cache[6] = ($event) => (_ctx.onDateSelected()))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4), [
                    [_vModelText, _ctx.selectedDate]
                ])
            ]))
            : _createCommentVNode("v-if", true),
        (_ctx.showLargePicker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_LargePicker, {
                    futureYearsRange: _ctx.futureYearsRange,
                    pastYearsRange: _ctx.pastYearsRange,
                    allowPastDates: _ctx.allowPastDates,
                    selectedDate: _ctx.selectedDate,
                    onDateChanged: _cache[7] || (_cache[7] = ($event) => (_ctx.onDateSelected($event)))
                }, null, 8 /* PROPS */, ["futureYearsRange", "pastYearsRange", "allowPastDates", "selectedDate"])
            ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */));
}
